import { useAuthStore } from '~/stores/useAuthStore'

/**
 * Hydrate auth from the server session when a cookie is present.
 */
export default defineNuxtPlugin(async () => {
  const { loggedIn } = useUserSession()
  const auth = useAuthStore()
  if (loggedIn.value) {
    await auth.hydrate()
  } else {
    auth.hydrated = true
  }
})
